import stMovingHubButton from './movingHubButton.component';

export default angular
  .module('st.Integrations.MovingHub', ['st.Core', 'angular-cache'])
  .component('stMovingHubButton', stMovingHubButton)
  .service('movingHubService', ($http, dataService, MOVING_HUB) => ({
    activate: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        MOVING_HUB.API.ACTIVATE,
        {
          params
        },
        ['idUser'],
        true
      ),
    send: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        MOVING_HUB.API.SEND,
        {
          params
        },
        null,
        true
      )
  }))
  .constant('MOVING_HUB', {
    API: {
      ACTIVATE: '/api/v1/integration/movingHub/activate',
      SEND: '/api/v1/integration/movingHub/refer'
    },
    FORM_FIELDS: {
      APPLICATION_TYPES: [
        {
          id: 1,
          value: 'Home'
        },
        {
          id: 2,
          value: 'Business'
        }
      ],
      OFFER_TYPES: [
        {
          id: 2,
          value: 'Moving'
        },
        {
          id: 6,
          value: 'Not moving'
        }
      ]
    }
  });
